import { Box, Typography } from "@mui/material";
import sarIcon from "src/assets/svg-icons/sar.svg";

interface IProps {
  label: string;
  value: string;
  isMoney?: boolean;
  description?: string;
}

const InfoItem = ({ label, value, isMoney, description }: IProps) => {
  return (
    <Box>
      <Typography fontWeight={600} fontSize={{ xs: "12px", md: "15px" }}>
        {label}
      </Typography>
      <Typography
        color={"#ACA8A8"}
        fontWeight={600}
        fontSize={{ xs: "12px", md: "15px" }}
      >
        {isMoney ? (
          <>
            <img height={12} src={sarIcon} alt="" />{" "}
          </>
        ) : null}
        {value}
        {description && (
          <Typography fontSize={"12px"} component={"span"} color={"#4EBE86"}>
            {" "}{description}
          </Typography>
        )}
      </Typography>
    </Box>
  );
};

export default InfoItem;
